document.addEventListener('DOMContentLoaded', function() {
  // カウントアップ
  // -----------------------------------------------------------------------------------
  // -----------------------------------------------------------------------
  const dur = 300;   // スピードはここで調整
  // -----------------------------------------------------------------------
  let countList = document.querySelectorAll('.is_count_up');
  let vw = window.innerWidth;
  // 数字を覆う<span>のwidthとheightを確保
  Arr(countList).forEach(function(countNum) {
    countNum.style.textAlign = 'right';
  });
  // 数字を1文字ずつ<span>で区切る
  separateNumber(Arr(countList));
  // 区切り終えた<span>それぞれにdata属性を付与し、テキストをクリア
  let standbyList = document.querySelectorAll('.count_standby');
  Arr(standbyList).forEach(function(num) {
    num.dataset.countUp = num.textContent;
    num.textContent = '';
  });
  // 親要素からの相対的なインデックスをdata属性に付与
  Arr(countList).forEach(function(wrap) {
    let children = wrap.querySelectorAll('.count_standby');
    let len = children.length;
    wrap.dataset.len = len;
    Arr(children).forEach(function(that) {
      that.dataset.countIndex = len - 1 - Arr(children).indexOf(that);
    });
  });
  // スクロールして要素が指定位置に来たら発火
  window.addEventListener('scroll', function() {
    // スクロール量取得(ページ下端)
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    // カウント処理
    Arr(standbyList).forEach(function(num) {
      // それぞれの発火対象要素(数字をまとめているspan.is_count_upまで)の絶対位置
      let tgrPos = num.parentNode.getBoundingClientRect().top + window.pageYOffset;
      if((tgrPos < scrollTop + window.innerHeight * 0.8)
      && (num.classList.contains('count_standby'))
      ){
        // クラス変更
        num.className = 'counting';
        setTimeout(function() {
          countFunc(num, dur);
        }, Number(num.dataset.countIndex) * dur);
      }
    });
    // 
  });

  // ちょるるフェードイン
  // -----------------------------------------------------------------------------------
  let crrTgr = document.querySelectorAll('.crr_trigger');
  window.addEventListener('scroll', function() {
    Arr(crrTgr).forEach(function(that) {
      // スクロール量取得(ページ下端)
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      let tgrPos = that.getBoundingClientRect().top + window.pageYOffset;
      if(tgrPos < scrollTop + window.innerHeight * 0.75) {
        that.classList.add('crrOn');
      }
    });
  });
});

// IE11用 NodeListをArrayに。
function Arr(nodeList) {
  return Array.prototype.slice.call(nodeList,0);
}

// IE11用 isNaNのpolyfill
Number.isNaN = Number.isNaN || function(any) {
  return typeof any === 'number' && isNaN(any);
};

// テキストを1文字ずつ<span>に分割
function separateNumber(targetNodeList) {
  let resultText = [];
  targetNodeList.forEach(function(elem) {
    let separateText = elem.textContent;
    resultText = separateText.split('').map(function(value) {
      let span = document.createElement('span');
      if(!Number.isNaN(Number(value))) {
        span.className = 'count_standby';
        span.style.display = 'inline-block';
      } else {
        span.className = 'display_standby'
        span.style.display = 'none';
      }
      span.textContent = value;
      return span;
    });
    elem.textContent = '';
    resultText.forEach(function(span) {
      elem.appendChild(span);
    });
  });
}

// カウントアップ
function countFunc(elem, dur) {
  const DURATION = dur;

  const FROM = Number(elem.dataset.countUp) + 1;
  const TO = Number(elem.dataset.countUp) + 10;
  const startTime = Date.now();
  // 処理開始
  const timer = setInterval(function() {
  const elapsedTime = Date.now() - startTime;
  const progress = elapsedTime / DURATION;
  if (progress < 1) {
    elem.innerHTML= Math.floor(FROM + progress * (TO - FROM)) % 10;
  } else {
    elem.innerHTML = TO % 10;
    clearInterval(timer);
    if(elem.previousElementSibling !== null && elem.previousElementSibling.classList.contains('display_standby')) {
      elem.previousElementSibling.style.display = 'inline-block';
    }
    elem.className = 'counted';
  }
  }, 10);
}